export function formatPrice (price) {
  return price
    ? (+price)?.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      useGrouping: false
    })
    : price
}

export function formatVolume (volume) {
  return volume
    ? (+volume)?.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      useGrouping: false
    })
    : volume
}
